import qs from 'qs';

const stringifyOptions = {
  arrayFormat: 'repeat',
  skipNulls: true,
};

const parseOptions = {
  ignoreQueryPrefix: true,
};

export const parseQuery = (search = '') => qs.parse(search, parseOptions);

export const stringifyQuery = (query = {}) => qs.stringify(query, stringifyOptions);

export const isDebugQueryEnabled = (query = {}) => {
  const value = Array.isArray(query.debug) ? query.debug.at(-1) : query.debug;
  return value === '1';
};
